import React, { useEffect, useState } from 'react';
import DataTable from '../common/DataTable';
import { numOfPage, TaskListingColumns, TaskListingSellerColumns } from '../../constant';
import { useDispatch, useSelector } from 'react-redux';
import BatchPagination from '../batch/BatchPagination';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import DatePicker from "react-datepicker";
import { getAllTaskListing } from '../../store/actions/picker.action';
import LoaderSpinner from '../common/Loader';
import ProductListingFilter from '../Inventory/Product/ProductListingFilter';
import _ from 'lodash';
import SearchCarrierConnect from '../CarrierConnect/SearchCarrierConnect';
import { taskBackDetails } from '../../store/actions/employee';

/*istanbul ignore next */
const TasksListing = () => {
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [dateRange, setDateRange] = useState([null, null]);
    const { taskPrevState } = useSelector((state) => state.employee);
    const [startDate, endDate] = dateRange;
    let dispatch = useDispatch();
    const userDetails = useSelector((state) => state.auth.user);
    const [sellerList, setSellerList] = useState([]);
    const [allSellers, setAllSellers] = useState([]);

    let dataLoad = {
        pageIndex: 1,
        pageSize: 30,
        totalPages: 1,
        sortColumn: '',
        sortOrder: 'DESCENDING',
        searchKeyword: '',
        sellerIdList: [],
        companyIdList: [],
        taskTypeIdList: [],
        taskStatusIdList: [],
        taskPriorityIdList: [],
        taskStatusList: [],
        showFilter: false,
        showSearch: false,
        startDate: null,
        endDate: null,
        searchText: '',
    }

    const [filterData, setfilterData] = useState({});
    const { allTaskList, allTaskListStatus } = useSelector((state) => state.pickerReducer);
    const [allTasksList, setAllTasksList] = React.useState([]);

    useEffect(() => {
        if (!_.isEmpty(taskPrevState)) {
            setfilterData({ ...filterData, ...taskPrevState });
        } else {
            setfilterData({ ...dataLoad });
        }
    }, []);

    useEffect(() => {
        if (!_.isEmpty(filterData)) {
            getAllTasksList();
        }
    }, [filterData.pageSize, filterData.pageIndex, filterData.sortColumn, filterData.sortOrder, endDate]);

    const handleFilterApply = () => {
        setfilterData({ ...filterData, pageIndex: 1 });
        if (filterData.pageIndex === 1) {
            getAllTasksList();
        };
    }

    const getAllTasksList = () => {
        let data = {
            ...filterData,
            searchText: filterData?.searchText?.trim(),
            startDate: startDate ? moment(startDate).format('YYYY-MM-DDT00:00:00') : null,
            endDate: endDate ? moment(endDate).format('YYYY-MM-DDT00:00:00') : null,
            taskTypeIdList: _.map(filterData.taskTypeIdList, "id"),
            taskStatusIdList: _.map(filterData.taskStatusList, "id"),
            taskPriorityIdList: _.map(filterData.taskPriorityIdList, "id"),
            companyIdList: _.map(filterData.companyIdList, "Id"),
            sellerIdList: _.map(filterData.sellerIdList, "id"),
        };
        dispatch(getAllTaskListing(data));
    }

    const getStatusClass = (status) => {
        switch (status) {
            case 'Hold':
                return 'activeStatus activeStatusRefunded';
            case 'In-Progress':
                return 'activeStatus taskInprogress';
            case 'Pending':
                return 'activeStatus activeStatusInprogress';
            case 'Completed':
                return 'activeStatus';
            case 'Canceled':
                return 'activeStatus activeStatusCanceled';
            case 'Closed':
                return 'activeStatus activeStatusClosed';
            default:
                return 'activeStatus uploads';
        }
    };

    useEffect(() => {
        if (allTaskListStatus === 'PENDING') {
            setLoader(true);
        } else if (allTaskListStatus === 'SUCCESS' && !_.isEmpty(filterData)) {
            const enrichedList = allTaskList.listTasks.map(item => ({
                ...item,
                listIndex: item.id,
                taskStatusName: `<span class="${getStatusClass(item.taskStatusName)}">${item.taskStatusName}</span>`
            }));
            setfilterData({
                ...filterData,
                totalPages: Math.ceil(allTaskList?.TotalRecords / filterData.pageSize),
            });
            setAllTasksList(enrichedList);
            setLoader(false);
        }
    }, [allTaskListStatus]);

    const handleAction = (item, type) => {
        dispatch(taskBackDetails(filterData));
        navigate(`/tasks/${item.id}`, {
            state: {
                data: item,
                editable: type === 'view' ? false : true,
            },
        });
    };

    const handleSortingColumn = (key) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        setfilterData({
            ...filterData,
            sortColumn: key,
            sortOrder: newSortOrder,
            pageIndex: 1
        });
    };

    const handleNavigate = () => {
        navigate(`/tasks/0`, {
            state: {
                data: {},
                editable: true,
            },
        });
    }

    const handleDateChange = (date) => {
        setDateRange(date);
    };

    const handleSearchText = (value) => {
        setfilterData({ ...filterData, searchText: value });
    };

    const handleReset = () => {
        const updatedFilterData = { ...filterData, searchText: '', pageIndex: 1 };
        setfilterData(updatedFilterData);

        // Call getAllTasksList with the updated data directly
        let data = {
            ...updatedFilterData,
            searchText: '', // Explicitly set to empty string
            startDate: startDate ? moment(startDate).format('YYYY-MM-DDT00:00:00') : null,
            endDate: endDate ? moment(endDate).format('YYYY-MM-DDT00:00:00') : null,
            taskTypeIdList: _.map(updatedFilterData.taskTypeIdList, "id"),
            taskStatusIdList: _.map(updatedFilterData.taskStatusList, "id"),
            taskPriorityIdList: _.map(updatedFilterData.taskPriorityIdList, "id"),
            companyIdList: _.map(updatedFilterData.companyIdList, "Id"),
            sellerIdList: _.map(updatedFilterData.sellerIdList, "id"),
        };
        dispatch(getAllTaskListing(data));
    };

    const handleFilterReset = () => {
        setfilterData((prevState) => ({
            ...prevState,
            pageIndex: 1,
            sellerIdList: [],
            companyIdList: [],
            taskTypeIdList: [],
            taskStatusIdList: [],
            taskPriorityIdList: [],
            showFilter: false,
        }));
        dispatch(getAllTaskListing({ ...dataLoad }));
        dispatch(taskBackDetails({}));
    };

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec zIndex3">
                    <span>Tasks</span>
                    <div className="top_right_button_container">
                        <div className="pickHead">
                            <div className="fontFix mr-2">
                                <DatePicker
                                    className="date-picker form-control pr-4"
                                    selectsRange={true}
                                    startDate={startDate}
                                    endDate={endDate}
                                    onChange={(update) => {
                                        handleDateChange(update);
                                    }}
                                    dateFormat="MM-dd-yyyy"
                                    isClearable={true}
                                    iconPosition="right"
                                    popperPlacement="top-end"
                                    placeholderText="Select Date Range"
                                    maxDate={new Date()}
                                />
                            </div>
                            <button disabled={loader} className="btn cus-seconday-bg-btn" onClick={() => setfilterData({ ...filterData, showFilter: !filterData.showFilter })}>Filter</button>
                            <button
                                className="btn cus-seconday-bg-btn ml-2"
                                onClick={handleNavigate}
                            >
                                <i className="fa fa-plus" aria-hidden="true"></i> Create New
                            </button>
                        </div>
                    </div>
                </div>
                <div className='zIndex1'>
                    <SearchCarrierConnect
                        searchKeyword={filterData.searchText}
                        handleSearchText={handleSearchText}
                        handleSearchFilter={handleFilterApply}
                        handleReset={handleReset}
                        userDetails={userDetails}
                        placeholderText="Search by Company, Seller, Seller Code, STE Code, Title, Task Id, Comments or SKU"
                    />
                </div>
                {loader && (<div className="full-screen-spinner-overlay"><LoaderSpinner /></div>)}

                <div className='zIndex2'>
                    {filterData.showFilter && (
                        <ProductListingFilter
                            showFilter={filterData.showFilter}
                            dispatch={dispatch}
                            useSelector={useSelector}
                            filterData={filterData}
                            setfilterData={setfilterData}
                            fetchProductList={handleFilterApply}
                            handleReset={handleFilterReset}
                            sellerList={sellerList}
                            setSellerList={setSellerList}
                            allSellers={allSellers}
                            setAllSellers={setAllSellers}
                            type="task"
                        />
                    )}
                </div>
                <div className="main_content cus-page-content-sec srch-pt0 zIndex1">
                    <div className="main_content_table_history">
                        <div className="tableFixHead incomingTbl">
                            {allTaskListStatus === 'SUCCESS' && (
                                <DataTable
                                    headers={userDetails?.Value?.isSuperAdmin ? TaskListingColumns : TaskListingSellerColumns}
                                    tableData={allTasksList}
                                    actionType={3}
                                    handleAction={handleAction}
                                    handleSortingColumn={handleSortingColumn}
                                    tableDataStatus={allTaskListStatus}
                                    filterData={filterData}
                                />
                            )}
                        </div>
                    </div>
                    <BatchPagination
                        gridData={allTasksList}
                        totalVisualRecords={allTasksList?.length}
                        numberOfPage={filterData.pageSize}
                        numOfPage={numOfPage}
                        loader={loader}
                        currentPage={filterData.pageIndex}
                        totalPages={filterData.totalPages}
                        totalRecords={allTaskList?.TotalRecords || 0}
                        setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                        setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value, pageIndex: 1 })}
                    />
                </div>
            </div>
        </main>
    );
}

export default TasksListing;